export default __webpack_public_path__ + "static/media/users-circle-white-tc.46039790.svg";